// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__gZ1Rc","inputWrap":"Table_inputWrap__LyQZV","col":"Table_col__3xGde","bmiTooltip":"Table_bmiTooltip__3aaCv"};